var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBottom = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.199 18.6-.07 1.3h34.742l-.07-1.3H25.2Zm-2.512 46.8 1.968-36.659c2.987-.774 5.286-3.212 5.804-6.241h10.716v1.3c0 .718.593 1.3 1.325 1.3s1.326-.582 1.326-1.3v-1.3H54.54c.518 3.03 2.817 5.466 5.805 6.241L62.313 65.4H48.94l-5.126-32.67A1.317 1.317 0 0 0 42.5 31.6c-.667 0-1.218.483-1.312 1.111L36.06 65.4H22.687Zm37.508-39.463L60.01 22.5h-2.76a5.24 5.24 0 0 0 2.945 3.437ZM27.751 22.5a5.24 5.24 0 0 1-2.946 3.438l.184-3.438h2.762Zm-5.167-4.652C22.64 16.811 23.512 16 24.57 16h35.86c1.058 0 1.93.812 1.986 1.848l2.581 48.1c.06 1.115-.846 2.052-1.986 2.052h-14.64c-.981 0-1.816-.702-1.965-1.654L42.5 41.45l-3.906 24.897c-.149.952-.984 1.654-1.965 1.654h-14.64c-1.14 0-2.046-.937-1.986-2.052l2.581-48.1ZM42.5 26.4c.732 0 1.326.582 1.326 1.3V29c0 .718-.594 1.3-1.326 1.3a1.313 1.313 0 0 1-1.325-1.3v-1.3c0-.718.593-1.3 1.325-1.3Z",
    fill: "currentColor"
  }))));
};
export { SvgBottom as ReactComponent };